export default "__VITE_ASSET__unOsov1S__"